// extracted by mini-css-extract-plugin
module.exports = {"container":"_39HGi","video":"_1i1Gk","cartouche":"z6iSH","description":"_3q9w5","cta":"_1zDqr","transcriptionButton":"_34Mh_"};